/* eslint-disable import/prefer-default-export */
import React, { useEffect, useState } from 'react'
import AuthModal from 'components/modal/AuthModal'

import s from './SaveButton.module.css'
import Collections from '../../../../collections/Collections/Collections'
import { Saved } from './Saved'

function gtagReportConversion(url) {
  var callback = function () {
    if (typeof url != 'undefined') {
      window.location = url
    }
  }
  // eslint-disable-next-line no-undef
  gtag('event', 'likelisting', {
    send_to: 'AW-968054781/WSr4CPT3orwYEP2vzc0D',
    event_callback: callback,
  })
  return false
}

export const SaveButton = (props) => {
  const { id, saved, signedIn, type } = props

  const [isSaved, setIsSaved] = useState(false)

  const [showCollections, setShowCollections] = useState(false)

  useEffect(() => {
    setIsSaved(saved)
  }, [saved])

  const toggleLike = (e) => {
    e.preventDefault()

    if (signedIn === false) {
      return
    }

    gtagReportConversion()
    setShowCollections((state) => !state)
  }

  return (
    <>
      <div className={s.root} {...(signedIn && { onClick: toggleLike })}>
        {!signedIn ? (
          <AuthModal>
            <Saved className={isSaved ? s.saveIconSaved : s.saveIcon} />
          </AuthModal>
        ) : (
          <Saved className={isSaved ? s.saveIconSaved : s.saveIcon} />
        )}
      </div>

      {showCollections && <Collections unitId={id} onClose={() => setShowCollections(false)} />}
    </>
  )
}
